import { TIME_VIEWS, type TimeView } from './timeOptions';

/** The search of `/time-entries`: the view it opens on (`AM-475`). */
export interface MyTimeSearch {
  view?: TimeView;
}

/**
 * `?view=` opens "Mis horas" on one of its views, as "Ver todo" of the card "Mis horas" of Inicio does
 * with "Esta semana" (`week`), the hours the card counts. Anything else is dropped, never thrown on.
 */
export function myTimeSearchSchema(search: Record<string, unknown>): MyTimeSearch {
  const view = search['view'];
  return typeof view === 'string' && (TIME_VIEWS as readonly string[]).includes(view)
    ? { view: view as TimeView }
    : {};
}
